import { render, staticRenderFns } from "./ExpertDetail.vue?vue&type=template&id=87322d3a&"
import script from "./ExpertDetail.vue?vue&type=script&lang=js&"
export * from "./ExpertDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExpertDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports